import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useSupplierInvoice, SupplierInvoice } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<SupplierInvoice>
      useData={useSupplierInvoice}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
